import React, { useEffect, useState } from 'react'
import { styled, Typography, TypographyProps } from '@mui/material'
import Tooltip from '../Tooltip'
import { isNilOrEmpty } from 'packages/core'

const StyledTypography = styled(Typography)({
    width: '100%',
    wordBreak: 'break-word',
    wordWrap: 'break-word',
    overflow: 'auto',
})

export interface TextFormatterProps extends TypographyProps {
    value?: string | null
    maxCharacters?: number
    tooltipDelay?: number
    tooltipStyles?: Record<string, any>
    tooltipProps?: Record<string, any>
    showTooltip?: 'always' | 'auto'
    ellipsis?: boolean
}

const TextFormatter: React.FC<TextFormatterProps> = (props) => {
    const {
        value,
        maxCharacters = 100,
        tooltipDelay = 1000,
        tooltipStyles,
        tooltipProps,
        showTooltip,
        ellipsis,
        ...rest
    } = props

    const [truncatedText, setTruncatedText] = useState<string | undefined>()

    useEffect(() => {
        let text

        if (value && value.length > maxCharacters) {
            text = `${value.substring(0, maxCharacters).trimEnd()}...`
        } else {
            text = value || undefined
        }

        return setTruncatedText(text)
    }, [value, maxCharacters])

    const nullValue = <span style={{ color: '#9b9b9b' }}>-</span>
    const ellipsisValue = (
        <Tooltip
            title={value ? value : ''}
            enterDelay={tooltipDelay}
            enterNextDelay={tooltipDelay}
            tooltipStyles={tooltipStyles}
            placement="bottom-start"
            {...tooltipProps}
        >
            <Typography noWrap {...rest}>
                {value}
            </Typography>
        </Tooltip>
    )

    const truncatedValue = (
        <Tooltip
            title={
                isNilOrEmpty(value)
                    ? ''
                    : showTooltip === 'always'
                        ? value
                        : value!.length > maxCharacters
                            ? value
                            : ''
            }
            enterDelay={tooltipDelay}
            enterNextDelay={tooltipDelay}
            tooltipStyles={tooltipStyles}
            {...tooltipProps}
        >
            <StyledTypography {...rest}>{truncatedText}</StyledTypography>
        </Tooltip>
    )

    return isNilOrEmpty(value)
        ? nullValue
        : ellipsis
            ? ellipsisValue
            : truncatedValue
}

export default TextFormatter

